import { Box } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import DropDownV3 from '../../../common/DropDownV3'
import MButton from '../../../common/MButton'
import TextBox from '../../../common/TextBox'
import { useDispatch, useSelector } from 'react-redux'
import { showErrorAlert, showSuccessAlert, updateLoadingScreen } from '../../../redux/Actions'
import { checkEmailValid, formatDecimal, generateChecksum, generateCommission, navigation1, navigation3, useDebouncedHandler } from '../../../utils/helpers'
import dayjs from 'dayjs'
import Information from '../../modal/Information'
import { bookingPaymentUnutilized, checkBeneficiaryStatus, generateQROrders, getBBTLoginCompany, getBBTPaymentConfig, getBookingDetailsToPrintAgents, getConsumed, updateBookingsInsertUpdate } from '../../../redux/Booking/BookingActions'
import AlertModalForSuccessPrint from '../../../common/AlertModalBkgPrint'
import DynamicQR from '../../modal/DynamicQR'
import UnutilizedPyt from '../../modal/UnutilizedPyt'
import EnquiryTwoModal from '../../modal/EnquiryTwoModal'
import { encryptText } from '../../../utils/encrypt'
import moment from 'moment'

const BottomSection = (props) => {
    const { bkgDeatails, selectedSeat = [], tripTotalAmt = {}, filterOpt = {}, setBkgDetails = () => { }, handleResetTrip = () => { } } = props
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const saveBtnRef = useRef(null);

    const [openModal, setOpenModal] = useState({
        id: 0,
        open: false,
        data: {},
        msg: '',
        transferFee: 0,
        commAmt: 0
    })
    const payModeProps = () => {
        return {
            width: "100%",
            name: "paymentMode",
            id: 'paymentMode',
            label: "Payment Mode",
            isCompulsory: false,
            options: filterOpt?.paymentMode || [],
            preSelectedValues: bkgDeatails?.paymentMode || [],
            searchPlaceholder: "Search by Payment Mode",
            disabled: false,
            isObject: true,
            primaryKey: 'id',
            labelKey: 'label',
            singleSelect: true,
            selectAllOption: false,
            defaultAllSelected: false,
            direction: "up",
            nextId: 'Save',
            prevId: bkgDeatails?.isDisableRemarks ? 'DropOff' : 'remarks',
        }
    }
    const handlePaymentMode = (val) => {
        setBkgDetails((prev) => ({
            ...prev,
            paymentMode: val
        }))
    }

    useEffect(() => {

        const handleKeyDown = (event) => {
            if (event.altKey && event.key.toLowerCase() === 's') {
                event.preventDefault();
                saveBtnRef.current?.click();
            }
        };
        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const handleValidation = (isUnutilized = false) => {
        if (filterOpt.bkgType.length === 0) {
            dispatch(showErrorAlert(`Insufficient Rights: Confirm and Phone Booking not allowed !! Comp. Code: ${bkgDeatails?.tripCompanyID} - Agt Code: ${userDetails.AgentID}`))
        } else if (bkgDeatails.bkgType.length === 0) {
            dispatch(showErrorAlert('Select Booking Type', 'bkgtype'))
        } else if (!checkEmailValid(bkgDeatails?.email?.trim()) && bkgDeatails?.email?.trim() !== '') {
            dispatch(showErrorAlert('Invalid EmailID', 'email'));
        } else if (bkgDeatails?.phoneNumber?.toString()?.trim() === '') {
            dispatch(showErrorAlert('Enter Mobile No', 'phoneNumber'));
        } else if (bkgDeatails?.phoneNumber?.toString()?.trim().length !== 10) {
            dispatch(showErrorAlert('Invalid Mobile No', 'phoneNumber'));
        } else if (bkgDeatails?.manualTicketNo?.toString()?.trim() !== '' && bkgDeatails?.manualTicketNo?.toString()?.trim().length < 5) {
            dispatch(showErrorAlert('Manual ticket number must be 5 characters', 'manualTicketNo'));
        } else if (selectedSeat.length === 0) {
            dispatch(showErrorAlert('Least One Seat should be selected', 'email'));
        } else {
            const hasSeatError = selectedSeat.some(obj => !obj.SeatLabel || obj.SeatLabel.toString().trim() === '');

            let checkBaseFare = false
            if (hasSeatError) {
                dispatch(showErrorAlert('Passenger Number and Select Seat should be the same', 'SeatLabel-0'))
                return true
            }

            let errorMsg = [];
            selectedSeat.forEach((obj) => {
                let seatErr = [];

                if (obj.name.toString().trim() === '') {
                    seatErr.push('name');
                }
                if (obj.gender?.length === 0) {
                    seatErr.push('gender');
                }
                if (seatErr.length > 0) {
                    errorMsg.push(
                        `Please provide ${seatErr.join(', ')} for passenger in seat ${obj.SeatLabel || '(unknown)'}.`
                    );
                }

                if (Number(obj.baseFare || 0) === 0) {
                    checkBaseFare = true
                }
            });
            if (errorMsg?.length > 0) {
                dispatch(showErrorAlert(errorMsg.join(`\n`), 'SeatLabel-0'))
                return true
            } else if (checkBaseFare) {
                dispatch(showErrorAlert('Booking cannot be performed with 0 seat fare', ''))
            } else if (bkgDeatails.paymentMode.length === 0) {
                dispatch(showErrorAlert('Select Payment Mode', ''))
            } else if (bkgDeatails.pickUp.length === 0) {
                dispatch(showErrorAlert('Select PickUp'))
            } else if (bkgDeatails.dropOff.length === 0) {
                dispatch(showErrorAlert('Select DropOff'))
            } else {
                if (isUnutilized) {
                    generateQRCode(false)
                } else {
                    setOpenModal((prev) => ({
                        ...prev,
                        id: 1,
                        open: true,
                        data: {},
                        msg: '',
                        commAmt: {}
                    }))
                }
            }
        }
    }
    const handleSave = (orderID = 0, pgTaxId = '') => {
        let tripDetails = bkgDeatails?.tripDetails || {}
        const body = {
            intBookingID: 0,
            intFromCityID: tripDetails?.FromCityID || 0,
            intToCityID: tripDetails?.ToCityID || 0,
            dtJourneyDate: dayjs(tripDetails?.JourneyDate, 'DD-MMM-YYYY').format('YYYY-MM-DD'),
            intTripID: tripDetails?.TripID,
            strBookingStatus: "B",
            strBookingType: bkgDeatails?.bkgType?.[0]?.id || '',
            intForAgentID: userDetails?.AgentID || 0,
            intForBranchID: 0,
            strTicketNo: "",
            intPaymentModeID: 1,
            intSeatCount: selectedSeat.length,
            dcmlTotalFare: tripTotalAmt?.baseFare || 0,
            dcmlDiscount: tripTotalAmt?.discount || 0,
            strPayoutCode: "C",
            dcmlSeaterLow: bkgDeatails?.seaterLow || 0,
            dcmlSeaterMedium: 0,
            dcmlSeaterHigh: bkgDeatails?.seaterHigh || 0,
            dcmlSlumberLow: bkgDeatails?.slumberLow || 0,
            dcmlSlumberMedium: 0,
            dcmlSlumberHigh: bkgDeatails?.slumberHigh || 0,
            dcmlSleeperLow: bkgDeatails?.sleeperLow || 0,
            dcmlSleeperMedium: 0,
            dcmlSleeperHigh: bkgDeatails?.sleeperHigh || 0,
            strPassengerName: selectedSeat?.[0]?.name,
            strPassengerContactNo1: bkgDeatails?.phoneNumber,
            strPassengerContactNo2: "",
            strPassengerEmailID: bkgDeatails?.email,
            strPaxDetails1: handlePaxDetails(selectedSeat?.[0] || {}),
            strPaxDetails2: handlePaxDetails(selectedSeat?.[1] || {}),
            strPaxDetails3: handlePaxDetails(selectedSeat?.[2] || {}),
            strPaxDetails4: handlePaxDetails(selectedSeat?.[3] || {}),
            strPaxDetails5: handlePaxDetails(selectedSeat?.[4] || {}),
            strPaxDetails6: handlePaxDetails(selectedSeat?.[5] || {}),
            strPaxDetails7: handlePaxDetails(selectedSeat?.[6] || {}),
            strPaxDetails8: handlePaxDetails(selectedSeat?.[7] || {}),
            strPaxDetails9: handlePaxDetails(selectedSeat?.[8] || {}),
            strPaxDetails10: handlePaxDetails(selectedSeat?.[9] || {}),
            strPaxDetails11: handlePaxDetails(selectedSeat?.[10] || {}),
            strPaxDetails12: handlePaxDetails(selectedSeat?.[11] || {}),
            intPickupID: bkgDeatails?.pickUp?.[0].pickup_id || 0,
            intDropoffID: bkgDeatails?.dropOff?.[0].DropoffId || 0,
            intUserIDBooked: 0,
            strUserIDBookedMode: "",
            strRemarks: bkgDeatails?.remarks || '',
            intGuestTypeID: 0,
            intBranchUserID: 0,
            intAutoCancelMins: bkgDeatails?.bkgType?.[0]?.id === 'AP' ? bkgDeatails?.autoCancelMins || 0 : 0,
            intSwipeIssuerID: 0,
            strCardNo: "",
            intAgentUserID: userDetails?.AgentUserID || 0,
            OrderID: "",
            PGUsed: "",
            PGUsed_Key: "",
            serviceCharge: bkgDeatails?.servicecharge || 0,
            qrOrderId: orderID,
            strpgtxnid: pgTaxId,
            paymentMode: bkgDeatails?.paymentMode?.[0].key || "Cash",
            dtChartDate: dayjs(tripDetails?.ChartDate, 'DD-MMM-YYYY').format('YYYY-MM-DD'),
            StrGSTN: bkgDeatails?.verfiyGst ? bkgDeatails?.gstNo || '' : '',
            ManualTicketNo: bkgDeatails?.manualTicketNo || ''
        }
        dispatch(updateBookingsInsertUpdate(body)).then((res) => {
            if (res.data?.status) {
                const bookingData = JSON.parse(res.data?.Data)?.Table?.[0];
                sessionStorage.setItem('lastBooking', JSON.stringify({ ...bookingData, paymentMode: bkgDeatails?.paymentMode?.[0].label || "Cash", }))
                localStorage.removeItem('BBTPhoneNumber')
                localStorage.removeItem('BBTPsgName')
                if (orderID !== 0) {
                    dispatch(getConsumed({ qrOrderId: orderID, Bookingid: bookingData.BookingID }))
                }
                if (bkgDeatails?.bkgType?.[0]?.id === 'AP') {
                    dispatch(showSuccessAlert(<>Booking <span style={{ color: '#ff7100', fontWeight: 'bold' }}>{bookingData.BookingID}</span> Done Successfully!</>))
                    handleResetTrip()
                } else {
                    setOpenModal((prev) => ({
                        ...prev,
                        id: 2,
                        open: true,
                        data: bookingData,
                        msg: <>Booking <span style={{ color: '#ff7100', fontWeight: 'bold' }}>{bookingData.BookingID}</span> Done Successfully!.<br />Do you want to print this ticket?</>,
                        commAmt: {}
                    }))
                }
            } else {
                dispatch(showErrorAlert(res.data?.Message || ''))
            }
        })
    }

    const handlePaxDetails = (obj) => {
        if (Object.keys(obj).length > 0) {
            let pickUpFare = formatDecimal(bkgDeatails?.pickUp?.length > 0 ? bkgDeatails?.pickUp?.[0]?.pickupCharge_per === 0 ? bkgDeatails?.pickUp?.[0]?.pickupCharge_rs : (Number(obj.baseFare) * Number(bkgDeatails?.pickUp?.[0]?.pickupCharge_per)) / 100 : 0)
            let dropOffFare = formatDecimal(bkgDeatails?.dropOff?.length > 0 ? bkgDeatails?.dropOff?.[0]?.DropoffChargePer === 0 ? bkgDeatails?.dropOff?.[0]?.DropoffChargeRs : (Number(obj.baseFare) * Number(bkgDeatails?.dropOff?.[0]?.DropoffChargePer)) / 100 : 0)
            return `1~${obj.SeatLabel}~${obj.name}~${obj?.gender?.[0]?.id || 'M'}~${obj.age.toString().trim() === '' ? 0 : obj.age}~${obj.baseFare}~${pickUpFare}~${dropOffFare}`
        } else {
            return `1~~~M~0~0~0~0`
        }
    }

    const handleInputField = (event) => {
        setBkgDetails((prev) => ({
            ...prev,
            remarks: event.target.value
        }))
    }

    const handleCloseModal = () => {
        setOpenModal((prev) => ({
            ...prev,
            id: 0,
            open: false,
            data: {},
            msg: '',
            transferFee: 0,
            commAmt: {}
        }))
    }
    const generateQRCode = (isQRCode = true) => {

        const beneficiaryStatusBody = {
            intCompanyID: bkgDeatails?.tripCompanyID || 0,
            intPaymentProductTypeID: 1,
            intBusinessVerticalID: 1,
        }

        dispatch(checkBeneficiaryStatus(beneficiaryStatusBody)).then((res) => {
            if (res?.data?.status) {
                let resParse = JSON.parse(res?.data?.Data || '{}')?.Table?.[0] || {}
                if (resParse?.IsActive === 1) {
                    getPaymentConfig(isQRCode, resParse,)
                } else {
                    dispatch(updateLoadingScreen(false));
                    dispatch(showErrorAlert(`QR Dynamic is Not Enable This Trip. Company Name : ${bkgDeatails?.tripDetails?.CompanyName} (${bkgDeatails?.tripDetails?.CompanyID})`))
                }
            } else {
                dispatch(updateLoadingScreen(false));
                dispatch(showErrorAlert(res?.data?.Message))
            }
        })




    }

    const getPaymentConfig = (isQRCode = false, resParse) => {
        const payConfigBody = {
            intCompanyID: bkgDeatails?.tripCompanyID,
            intAgentID: userDetails?.AgentID || 0,
            intTripID: bkgDeatails?.tripDetails.TripID,
            intFromCityID: bkgDeatails?.tripDetails.FromCityID,
            intToCityID: bkgDeatails?.tripDetails.ToCityID,
            intFareSeater: tripTotalAmt?.seaterCount > 0 ? tripTotalAmt?.seaterAmt : 0,
            intFareSlpr: tripTotalAmt?.sleeperCount > 0 ? tripTotalAmt?.sleeperAmt : 0,
            intFareSlm: tripTotalAmt?.sleeperCount > 0 ? tripTotalAmt?.slumperAmt : 0,
        }
        dispatch(getBBTPaymentConfig(payConfigBody)).then((res) => {
            if (res?.data?.status) {
                let commAmt = JSON.parse(res.data.Data || '{}')?.Table1?.[0] || {}
                if (isQRCode) {
                    handleQROrders(resParse, commAmt)
                } else {
                    getBookingPaymentUnutilized(resParse, commAmt)
                }
            } else {
                dispatch(showErrorAlert(res?.data.Message))
            }
        })

    }
    const handleQROrders = (data, commAmt) => {
        let transferfee = data?.TransactionFeePer || 0
        let amount = generateCommission(tripTotalAmt, commAmt, transferfee, commAmt)
        let transferFeeAmount = Math.round(((amount * Number(transferfee || 0)) / 100) * 100) / 100

        let body = {
            agentid: userDetails?.AgentID,
            agentuserid: userDetails?.AgentUserID,
            amount: Number(amount).toFixed(2),
            application: 'crs',
            branchid: 0,
            branchuserid: 0,
            companyid: bkgDeatails?.tripCompanyID || 0,
            deviceid: '',
            devicetype: 'web',
            paymentmethod: 'qr',
            tag1: 'bbt_booking',
            tag2: '',
            vertical: 'bus',
            transferfee: transferFeeAmount,
            checksum: '',
        }
        let checksum = generateChecksum(body)
        let crsCallback = `http://crsapi.bookbustickets.com/service.svc/BBTAppQrBkgDetailsInsertUpdate?intorderid=_OrderID_&decamount=${Number(amount)}&decpgcharge=${0}&decpgamount=${Number(amount)}&strstatus=${`PAYMENT_INITIATED`}&strmerchanttxnid=_MTxnID_&strpgtxnid=&dtstatustime=${moment().format('YYYY-MM-DD HH:mm:ss')}&intcompanyid=${bkgDeatails?.tripCompanyID || 0}&intentityid=${userDetails.AgentID}&strentitytype=A&BusinessVerticleId=1&paymentproducttypeid=9&entityPaymentid=0&userid=${userDetails.AgentUserID}&qrUTRNumber=&RechargeStatus=${`QR Generated`}&transferfee=${transferFeeAmount}&strpgname=&mobileno=${bkgDeatails?.phoneNumber || ''}&intbranchid=0&refStatus=&refStatusTime=${`01-01-0001 00:00:00`}&refUserID=${0}`
        dispatch(generateQROrders({
            ...body, checksum,
            extraInfo: {
                CrsCallback: crsCallback
            }
        })).then((res) => {
            dispatch(updateLoadingScreen(false));
            if (res?.data?.isSuccess) {
                setOpenModal((prev) => ({
                    ...prev,
                    id: 3,
                    open: true,
                    data: res?.data?.data,
                    msg: '',
                    transferFee: 0,
                    commAmt: {}
                }))
            } else {
                dispatch(showErrorAlert(res?.data?.error || 'Error in Generating QR Code'))
            }
        }).catch((error) => {
            dispatch(updateLoadingScreen(false));
            dispatch(showErrorAlert('Error in Generating QR Code'))
        });

    }

    const getBookingPaymentUnutilized = (data, commAmt) => {
        const body = {
            intCompanyID: bkgDeatails?.tripCompanyID || 0,
            intPaymentprdtID: 9,
            strStatus: 'PAYMENT_SUCCESS',
            BusinessVerticleId: 1,
            AgentID: userDetails?.AgentID || 0
        }
        dispatch(bookingPaymentUnutilized(body)).then((res) => {
            if (res?.data?.status) {
                let parseData = JSON.parse(res?.data?.Data)?.Table || []
                if (parseData?.length !== 0) {
                    setOpenModal((prev) => ({
                        ...prev,
                        id: 4,
                        open: true,
                        data: parseData,
                        msg: '',
                        transferFee: data?.TransactionFeePer || 0,
                        commAmt: commAmt,
                    }))
                } else {
                    dispatch(showErrorAlert('No Payment Unutilized Found'))
                }

            } else {
                dispatch(updateLoadingScreen(false))
                dispatch(showErrorAlert(res?.data?.Message))
            }
        })
    }

    const debouncedInputField = useDebouncedHandler(handleInputField, 500);

    const handlePrint = (data) => {

        const printBody = {
            intBookingID: data.BookingID,
            intBranchID: 0,
            intUserID: userDetails?.AgentUserID || 0
        }
        dispatch(getBookingDetailsToPrintAgents(printBody)).then((res) => {
            if (res.data?.status) {
                let ticketFormatID = JSON.parse(res.data?.Data || "{}")?.Table?.[0]?.TicketFormatID || 0
                if (ticketFormatID === 0) {
                    window.open(`http://bookbustickets.com/PrintTicket_Agent.aspx?bkgID=${data.BookingID}&pnr=${data.BookingID}&uid=${userDetails.AgentUserID}&utype=A`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
                } else {
                    window.open(`http://bookbustickets.com/PrintTicket_Format.aspx?bkgID=${data.BookingID}&pnr=${data.BookingID}&ticketFormatID=${ticketFormatID}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
                }
                handleResetTrip()
            } else {
                dispatch(showErrorAlert(res.data?.Message))
                handleResetTrip()
            }
        })

    }
    return (
        <>
            <Box className='bottom_Section'>
                <Box sx={{ flex: 1 }} className='smallTextBox28'>
                    <TextBox label={'Remarks'} type={'text'} id='remarks' disabled={bkgDeatails.isDisableRemarks} value={bkgDeatails?.remarks} onChange={debouncedInputField}
                        onKeyDown={(event) => {
                            navigation1(event, 'paymentMode', 'DropOff')
                        }} />
                </Box>
                <Box className='smallDropDownp28' sx={{ width: '150px' }}>
                    <DropDownV3
                        {...payModeProps()}
                        onSelect={handlePaymentMode}
                    />
                </Box>

                <Box>
                    <MButton ref={saveBtnRef} className='btn-orange28' btnName='Save' id='Save' onClick={() => {
                        handleValidation()
                    }}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                handleValidation()
                            }
                            navigation3(event, "", 'paymentMode', () => {
                                handleValidation()
                            })
                        }}

                    />
                </Box>
                {bkgDeatails.paymentMode?.[0]?.id === 2 &&
                    <Box>
                        <MButton variant='outlined' className='btn-orange-outline28' btnName='Unutilized' id='Load' onClick={() => {
                            handleValidation(true)
                        }} />
                    </Box>
                }
                <Box className='enquiryButtons28'>
                    <MButton variant='outlined' className='btn-blue-outline28' btnName='Enquiry 1'
                        onClick={() => {
                            const params = {
                                intAgentID: userDetails?.AgentID,
                                intFromCityId: bkgDeatails.tripDetails.FromCityID,
                                intToCityID: bkgDeatails.tripDetails.ToCityID,
                                dtJourneyDate: bkgDeatails.tripDetails.ChartDate,
                                intTripID: bkgDeatails.tripDetails.TripID,
                                intRouteName: bkgDeatails.tripDetails.ServiceName,
                                intBusNumber: bkgDeatails.tripDetails.BusNumber ?? 0,
                                intBusTypeID: bkgDeatails.tripDetails.BusTypeID ?? 0,
                            }
                            window.open(`/inquriyOneReport?data=${encodeURIComponent(encryptText(JSON.stringify(params)))}`, "_blank");
                        }}
                    />
                </Box>
                <Box className='enquiryButtons28'>
                    <MButton variant='outlined' className='btn-blue-outline28' btnName='Enquiry 2'
                        onClick={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 5,
                                open: true,

                            }))
                        }}
                    />
                </Box>
            </Box>

            {openModal.open &&
                <>
                    {openModal.id === 1 &&
                        <Information open={openModal.id === 1} bkgDeatails={bkgDeatails} tripTotalAmt={tripTotalAmt}
                            seat={selectedSeat.map((obj) => (obj.SeatLabel)).join(',')}
                            onClose={() => {
                                handleCloseModal()
                            }}
                            handleGenerateTicket={() => {
                                if (bkgDeatails.paymentMode?.[0].id === 1) {
                                    handleSave()
                                } else if (bkgDeatails.paymentMode?.[0].id === 2) {
                                    generateQRCode()
                                }
                                handleCloseModal()

                            }}
                        />
                    }
                    {openModal.id === 2 &&
                        <AlertModalForSuccessPrint open={openModal.id === 2}
                            onClose={() => {
                                handleCloseModal()
                                handleResetTrip()
                            }}
                            onConfirm={() => {
                                handlePrint(openModal.data)
                            }}
                            message={openModal.msg}
                        />
                    }
                    {openModal.id === 3 &&
                        <DynamicQR open={openModal.id === 3}
                            bkgDetails={bkgDeatails}
                            onClose={handleCloseModal}
                            data={openModal.data}
                            handlePaymentSuccess={(orderID = 0, pgTaxId = '') => {
                                handleSave(orderID, pgTaxId)
                            }}
                        />
                    }
                    {openModal.id === 4 &&
                        <UnutilizedPyt
                            open={openModal.id}
                            titleText='Unutilized Payment'
                            bkgDeatails={bkgDeatails}
                            data={openModal.data || []}
                            bkgTotal={{
                                grandTotal: generateCommission(tripTotalAmt, openModal?.commAmt, openModal?.transferFee || 0),
                            }}
                            onClose={handleCloseModal}
                            handleGenerateTicket={(orderID = 0, pgTaxId = '') => {
                                handleSave(orderID, pgTaxId)
                            }}
                            tripTotalAmt={tripTotalAmt}
                            selectedSeat={selectedSeat}
                        />
                    }
                    {openModal.id === 5 &&
                        <EnquiryTwoModal
                            open={openModal.id === 5}
                            titleText='Enquiry 2 Report'
                            bkgDeatails={bkgDeatails}
                            onClose={handleCloseModal}
                        />
                    }
                </>

            }

        </>
    )
}

export default BottomSection